/**
 * Just a 3x24 orange rectangle.
 **/
const Line = ({className = ""}) => {
	return (
		<div className={`inline-block h-[3px] w-6 bg-rich-orange ${className}`} />
	);
};

export default Line;
